import type { Router } from "vue-router";
import { userSidebarStore } from "@/app/store/SidebarStore";
import { useLoginStore } from "@/app/store/LoginStore";
import { nextTick } from "vue";
import { setUserSidebar } from "@/app/util/route";
import { verifyRouter, verifySession } from "@/api/login/LoginApi";

export const navigationGuardStudent = (router: Router): void => {
  // 앱 타이틀(환경변수) — document.title 뒤에 붙임
  const appTitle = import.meta.env.VITE_APP_TITLE;
  const sidebarStore = userSidebarStore();
  const loginStore = useLoginStore();

  // app load후 첫 진입때 세션체크
  router.beforeEach(async (to, _from, next) => {
    const toMeta = to.meta;
    console.info("🚀", _from.fullPath, "→", to.fullPath);

    // 0) 에러페이지는 바로 통과
    if (to.name === "noServer" || to.name === "error") {
      return next();
    }

    // 1) 메뉴 구성 전이라면 메뉴 구성
    if (!sidebarStore.getRouteYn) {
      const res = await setUserSidebar();
      if (!res) return next(false);
    }

    // 2) 세션 검증이 없으면 세션 검증 수행(새로고침 및 첫진입)
    if (!loginStore.getSessionChk) {
      const res = await verifySession();
      if (res != null) loginStore.setLoginInfo(res);
      loginStore.setSessionChk(true);
    }

    // 3) 정적 라우트는 권한 체크 없이 통과
    if (Object.keys(toMeta).length !== 0 && !toMeta.isDynamic) {
      return next();
    }

    // 4) 서버에 이 라우트에 대한 권한이 있는지 확인
    const res = await verifyRouter({ url: to.path, menuCd: toMeta.menuCd });
    if (res) {
      await loginStore.setApiAuth(res);
      console.info("[Allowed method in '" + String(to.path) + "'] " + loginStore.getApiAuth);
      return next();
    }
    // 권한이 없으면 접근 거부
    return next(false);
  });

  router.afterEach(async (to) => {
    const toMeta = to.meta;
    // 페이지 타이틀 기본값 설정(타이틀 + 앱이름)
    let title = toMeta.title ? " - " + toMeta.title : "";
    // 세션 언어가 영문이면 가능하면 titleEn 사용
    if (sessionStorage.getItem("lang") === "en" && toMeta.titleEn) {
      title = " - " + toMeta.titleEn;
    }
    document.title = appTitle + title;

    // DOM 업데이트 / 상태 반영 대기
    await nextTick();
  });
};
